import { NgModule } from "@angular/core";
import { FxFlexAlignDirective } from "./fx-flex-align.directive";
import { FxFlexDirective } from "./fx-flex.directive";
import { FxHideDirective, FxShowDirective } from "./fx-visibility.directive";
import { FxLayoutAlignDirective } from "./fx-layout-align.directive";
import { FxLayoutDirective } from "./fx-layout.directive";
import { FxLayoutGapDirective } from "./fx-layout-gap.directive";

@NgModule({
  declarations: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, FxFlexAlignDirective, FxShowDirective, FxHideDirective],
  exports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, FxFlexAlignDirective, FxShowDirective, FxHideDirective]
})
export class FlexLayoutCompatModule {}
